module.exports = __webpack_public_path__ + "static/media/plass_logo_new.fe5b4387.svg";